/**
 * Provides the current traffic model ID which is the traffic model number for the viewport needed for the Traffic API -
 * Incidents Layer, and the {{#crossLink "IncidentDetails"}}Traffic API - Incident Details{{/crossLink}}
 * calls.
 *
 * It is updated every minute, and is valid for two minutes before it times out.
 *
 * Parameters need to be passed to the constructor.
 * The method {{#crossLink "Services.services.incidentViewport/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class incidentViewport
 * @namespace Services.services
 * @uses GoMixin
 * @module Services
 * @uses KeyMixin
 * @uses ProtocolMixin
 * @constructor
 * @param {Object} [options]
 * @example
 * ```js
 * function callbackFn(response) {
 *   console.log(response);
 * }
 * tt.services.incidentViewport({
 *   key: <Your API key>
 * })
 * .go()
 * .then(callbackFn);
 * ```
 */
import {SERVICE_TYPES} from 'Core/serviceTypes';
import validators from './validators';
import { incidentViewportRest } from '../rest/incidentViewport';
import model from '../model/traffic/incidentViewport';
import serviceFactory from './serviceFactory';

const fields = {
    key: {
        validators: [validators.key]
    },
    protocol: {
        validators: [validators.oneOfValue(['http', 'https'], 'protocol')]
    },
    sessionId: {
        validators: [validators.string]
    }
};

function handleServiceCall(data) {
    return incidentViewportRest(fields, data).then(response => model(response));
}

export const incidentViewport =
    serviceFactory(fields, SERVICE_TYPES.TRAFFIC_INCIDENTS, 'incidentViewport', handleServiceCall);



// WEBPACK FOOTER //
// ./services/services/incidentViewport.js